import { ElfLoggerConfig } from './elf-log.model';

/**
 * Build-time version stamp for the buyer onboarding web bundle. CRA's module
 * scope prevents importing package.json from outside src, so the version is
 * mirrored here (keep in sync with package.json "version").
 */
export const APP_VERSION = '0.1.0';

/**
 * ELF (Enterprise Logging Framework) client logging config for buyer onboarding.
 * Mirrors the `elf` block used by one-ap-customer_web, aligned with the server
 * OTEL resource attributes defined in helm (service.name=oneap-onboarding-app,
 * service.namespace=oneap, service.car.id=600000698).
 */
export const elfConfig: ElfLoggerConfig = {
  enabled: true,
  logsEndpoint: '/otlp/v1/logs',
  serviceName: 'oneap-onboarding-app',
  serviceNamespace: 'oneap',
  carId: '600000698',
  scopeName: 'one-ap-buyer_onboarding_web',
  batchSize: 20,
  flushIntervalMs: 5000
};
